import { I18n } from '../../services/i18n'

export default () => rootScope => (key, args = {}) =>
  I18n.t(`ui.${rootScope}.${key}`, args);
